import { Notyf } from 'notyf';

// Colors mirror variables.less @success/@danger — Notyf applies these inline,
// so they can't reference the LESS tokens directly; keep in sync manually.
export default new Notyf({
    duration: 5000, // matches toastr's default timeOut
    position: { x: 'right', y: 'bottom' }, // matches toastr.options.positionClass = 'toast-bottom-right'
    types: [
        { type: 'success', background: '#198754' },
        { type: 'error', background: '#dc3545' },
    ],
});
